import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import screeningOperations from './screening-operations';
import { AnxietyType, ScreeningState } from './screening.interface';

const initialState: ScreeningState = {
  anxietyTypesList: [],
  questionsList: [],
  oneType: null,
  isLoading: false,
  error: null,
};

const handlePending = state => {
  state.isLoading = true;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const screeningSlice = createSlice({
  name: 'screening',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    reviewsClearError: state => {
      state.error = null;
    },
  },

  extraReducers: builder => {
    builder
      .addCase(screeningOperations.fetchAnxietyTypes.pending, handlePending)
      .addCase(
        screeningOperations.fetchAnxietyTypes.fulfilled,
        (state, action: PayloadAction<AnxietyType[]>) => {
          state.anxietyTypesList = action.payload;
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(screeningOperations.fetchAnxietyTypes.rejected, handleRejected)

      .addCase(screeningOperations.addAnxietyType.pending, handlePending)
      .addCase(
        screeningOperations.addAnxietyType.fulfilled,
        (state, action: PayloadAction<AnxietyType>) => {
          state.anxietyTypesList.push(action.payload);
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(screeningOperations.addAnxietyType.rejected, handleRejected)

      .addCase(screeningOperations.addAnxietyQuestion.pending, handlePending)
      .addCase(
        screeningOperations.addAnxietyQuestion.fulfilled,
        (state, action) => {
          state.questionsList.push(action.payload);
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(screeningOperations.addAnxietyQuestion.rejected, handleRejected)

      .addCase(screeningOperations.fetchAnxietyQuestions.pending, handlePending)
      .addCase(
        screeningOperations.fetchAnxietyQuestions.fulfilled,
        (state, action) => {
          state.questionsList = action.payload;
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(
        screeningOperations.fetchAnxietyQuestions.rejected,
        handleRejected
      )

      .addCase(
        screeningOperations.updateAnxietyType.fulfilled,
        (state, action) => {
          const index = state.anxietyTypesList.findIndex(
            t => t._id === action.payload._id
          );
          if (index !== -1) state.anxietyTypesList[index] = action.payload;
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(
        screeningOperations.deleteAnxietyType.fulfilled,
        (state, action) => {
          state.anxietyTypesList = state.anxietyTypesList.filter(
            t => t._id !== action.payload
          );
          state.isLoading = false;
          state.error = false;
        }
      )

      .addCase(
        screeningOperations.updateAnxietyQuestion.fulfilled,
        (state, action) => {
          const index = state.questionsList.findIndex(
            q => q._id === action.payload._id
          );
          if (index !== -1) state.questionsList[index] = action.payload;
          state.isLoading = false;
          state.error = false;
        }
      )
      .addCase(
        screeningOperations.deleteAnxietyQuestion.fulfilled,
        (state, action) => {
          state.questionsList = state.questionsList.filter(
            q => q._id !== action.payload
          );
          state.isLoading = false;
          state.error = false;
        }
      );
  },
});

export const { setError, reviewsClearError } = screeningSlice.actions;

export default screeningSlice.reducer;
